export const SUBSCRIPTION_KEY = "simuladinho-craques-do-enem2026";

// Grupo do WhatsApp exibido na tela de aguardando gabarito (WAITING_FEEDBACK)
export const WHATSAPP_GROUP_URL = "https://sndflw.com/i/qtYXh7zmtDxVeEISmmPz";

// Botão "Ver aulas de hoje" da tela BLOCKED: playlist de aulas no YouTube.
export const AULAS_HOJE_URL =
  "https://www.youtube.com/playlist?list=PLWkLxva8dPIv-7-IHXwX6JAThx5u2bHdm";

// ===== Banner final do gabarito (QR Code) e CTA "Garantir minha vaga" =====
// Mesmo link no botão "Garantir minha vaga" (card Aprova 180) e no QR Code do
// banner final — definido pelo nível (categoria) do aluno no gabarito.
export const APROVA_180_CTA_URLS = {
  TREINAMENTO:
    "https://aprovatotal.com.br/lp/enem-180/?seller=performance&source=paginas&utm_source=paginas&utm_medium=organic&utm_campaign=craques-do-enem-2026&utm_content=banner-gabarito-simulado-craques-TREINAMENTO",
  RESERVA_TECNICO:
    "https://aprovatotal.com.br/lp/enem-180/?seller=performance&source=paginas&utm_source=paginas&utm_medium=organic&utm_campaign=craques-do-enem-2026&utm_content=banner-gabarito-simulado-craques-RESERVA-TECNICO",
  TITULAR:
    "https://aprovatotal.com.br/lp/enem-180/?seller=performance&source=paginas&utm_source=paginas&utm_medium=organic&utm_campaign=craques-do-enem-2026&utm_content=banner-gabarito-simulado-craques-TITULAR",
  CRAQUE:
    "https://aprovatotal.com.br/lp/enem-180/?seller=performance&source=paginas&utm_source=paginas&utm_medium=organic&utm_campaign=craques-do-enem-2026&utm_content=banner-gabarito-simulado-craques-CRAQUE",
  // Aluno que não realizou o simulado (sem sufixo de categoria no utm_content).
  NO_ATTEMPT:
    "https://aprovatotal.com.br/lp/enem-180/?seller=performance&source=paginas&utm_source=paginas&utm_medium=organic&utm_campaign=craques-do-enem-2026&utm_content=banner-gabarito-simulado-craques",
};
// ===== Cupom do dia (card "Aprova ENEM 180" e banner do QR Code) =====
// O cupom e o desconto mudam a cada dia, sempre no fuso de São Paulo (UTC-3,
// sem horário de verão desde 2019). Chave = data 'YYYY-MM-DD' em SP.
export const GABARITO_COUPON_SCHEDULE = {
  "2026-06-08": { code: "CRAQUE15", percent: 15 }, // Seg
  "2026-06-09": { code: "CRAQUE10", percent: 10 }, // Ter
  "2026-06-10": { code: "CRAQUE5", percent: 5 }, // Qua
};

// Fuso de São Paulo em minutos (UTC-3 fixo, sem horário de verão).
const SP_UTC_OFFSET_MINUTES = -180;

// Converte um Date para o "horário de parede" de SP: os getters locais do Date
// retornado (getHours, getDate...) passam a refletir o relógio de São Paulo,
// independentemente do fuso do navegador do usuário.
const toSPWallClock = (date) => {
  const utcMs = date.getTime() + date.getTimezoneOffset() * 60000;
  return new Date(utcMs + SP_UTC_OFFSET_MINUTES * 60000);
};

// Horário (em SP) em que o cupom vira e o contador zera — normalmente o fim do
// dia. Para testar a virada sem esperar a meia-noite, basta mudar este horário.
const COUPON_ROLLOVER = { hours: 23, minutes: 59, seconds: 59 }; // prod: 23,59,59

// Formata um Date (já em horário de parede de SP) como 'YYYY-MM-DD'.
const formatSPDateKey = (sp) => {
  const y = sp.getFullYear();
  const m = String(sp.getMonth() + 1).padStart(2, "0");
  const d = String(sp.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

// Janela do cupom a partir de `now`: o cupom ativo e os ms restantes até a
// próxima virada. Ambos derivam do MESMO instante de virada — então, quando o
// contador zera, o cupom já é o do período seguinte e a interface troca junto.
const getCouponWindow = (now) => {
  const sp = toSPWallClock(now);

  const rollover = new Date(sp);
  rollover.setHours(
    COUPON_ROLLOVER.hours,
    COUPON_ROLLOVER.minutes,
    COUPON_ROLLOVER.seconds,
    0,
  );

  // Antes da virada de hoje => cupom/contador do dia atual. A partir da virada,
  // pula para o dia seguinte (cupom novo + contador reiniciado).
  const couponDay = new Date(sp);
  if (sp.getTime() >= rollover.getTime()) {
    rollover.setDate(rollover.getDate() + 1);
    couponDay.setDate(couponDay.getDate() + 1);
  }

  return {
    // null fora das datas mapeadas (campanha encerrada) => UI esconde o cupom.
    coupon: GABARITO_COUPON_SCHEDULE[formatSPDateKey(couponDay)] || null,
    remainingMs: Math.max(0, rollover.getTime() - sp.getTime()),
  };
};

// Cupom vigente conforme o dia em SP (null fora da campanha).
export const getCurrentCoupon = (now = new Date()) =>
  getCouponWindow(now).coupon;

// Milissegundos restantes até a próxima virada do cupom no dia atual em SP.
export const getCouponCountdownMs = (now = new Date()) =>
  getCouponWindow(now).remainingMs;
